export const NetworkStoreSizeTypes = {
    CompetitorsMain: 1,
    CompetitorsGreaterThanTwo: 2,
    CompetitorsLessThanTwo: 3
};



// WEBPACK FOOTER //
// ./src/constants/NetworkStoreSizeTypes.js